module.exports = __webpack_public_path__ + "img/fenway1.a41449e2.jpg";